import * as React from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

const MenuButton = ({name, titles, links, leftShift, anchorEl, open, handleMenuOpen, handleMenuClose}) => {

    const handleClick = (event) => {
        if (open) {
            handleMenuClose();
        } else {
            handleMenuOpen(event);
        }
    };

    React.useEffect(() => {
        const handleScroll = () => {
            if (open) {
                handleMenuClose();
            }
        };

        if (open) {
            window.addEventListener('scroll', handleScroll);
        }

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [open]);

    return (
        <div className={open ? 'menu-button-container menu-button-container-selected' : 'menu-button-container'}>
            <button
                className={open ? 'menu-button menu-button-selected' : 'menu-button'}
                id="menu-button"
                aria-controls={open ? 'menu-button' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}
            >
                <span>{name}</span>
                {open ? (
                    <KeyboardArrowUpIcon className="menu-arrow-icon" />
                ) : (
                    <KeyboardArrowDownIcon className="menu-arrow-icon" />
                )}
            </button>
            <Menu
                classes={{'paper': 'menu-button-paper'}}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                id="button-dropdown-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleMenuClose}
                disableScrollLock={true}
                sx={{
                    left: leftShift,
                    top: 84
                }}
                BackdropProps={{
                    sx: {
                        top: 84
                    },
                }}
            >
                {titles && links && titles.map((title, index) => (
                    <MenuItem
                        className="menu-button-item"
                        onClick={handleMenuClose}
                        disableRipple
                    >
                        <a className={'menu-button-link'} href={links[index]}>{title}</a>
                    </MenuItem>
                ))}
            </Menu>
        </div>
    );
};

export default MenuButton;